var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from "react";
import VTAudioRecorder, { ERecordingAndPlaybackState } from "./VTAudioRecorder";
import VTAudioPlayerCard from "./VTAudioPlayerCard";
import { Box } from "@mui/material";
import VTButton from "../VTButton";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
export var VTAudioRecorderAndPlayback = forwardRef(function (_a, ref) {
    var sx = _a.sx, defaultAudioTitleRecordingName = _a.defaultAudioTitleRecordingName, autoSelectTextOnEdit = _a.autoSelectTextOnEdit, onAudioTitleEdited = _a.onAudioTitleEdited, onAudioDataUrlReady = _a.onAudioDataUrlReady, onRecordingPlaybackStateChanged = _a.onRecordingPlaybackStateChanged;
    var _b = __read(useState(null), 2), currentAudioDataUrl = _b[0], setCurrentAudioDataUrl = _b[1];
    useEffect(function () {
        if (typeof currentAudioDataUrl === "string") {
            onAudioDataUrlReady && onAudioDataUrlReady(currentAudioDataUrl);
        }
    }, [currentAudioDataUrl]);
    var _c = __read(useState(ERecordingAndPlaybackState.PRE_RECORDING), 2), currentRecordingPlaybackState = _c[0], setCurrentRecordingPlaybackState = _c[1];
    return currentRecordingPlaybackState === ERecordingAndPlaybackState.PLAYBACK && currentAudioDataUrl ? (_jsxs(Box, __assign({ ref: ref, component: "div", sx: __assign({ position: "relative" }, sx) }, { children: [_jsx(VTButton, __assign({ type: "icon", sx: {
                    position: "absolute",
                    top: "8px",
                    left: "8px",
                    zIndex: 100000,
                    background: "rgb(0, 0, 0, 0.05)",
                    "&:hover": { background: "rgb(0, 0, 0, 0.2)" },
                }, onClick: function () {
                    setCurrentAudioDataUrl(null);
                    setCurrentRecordingPlaybackState(ERecordingAndPlaybackState.PRE_RECORDING);
                } }, { children: _jsx(ArrowBackRoundedIcon, {}) })), _jsx(VTAudioPlayerCard, { audioSrc: currentAudioDataUrl, title: defaultAudioTitleRecordingName, autoSelectTextOnEdit: autoSelectTextOnEdit, onTitleEdited: onAudioTitleEdited })] }))) : (_jsx(VTAudioRecorder, { ref: ref, sx: sx, onRecordingPlaybackStateChanged: function (newRecordingAndPlaybackState) {
            setCurrentRecordingPlaybackState(newRecordingAndPlaybackState);
            onRecordingPlaybackStateChanged && onRecordingPlaybackStateChanged(newRecordingAndPlaybackState);
        }, onRecordingFinished: function (blob) {
            setCurrentAudioDataUrl(URL.createObjectURL(blob));
        } }));
});
